module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAASCAYAAAAkAezhAAABP0lEQVRIidWVP04CQRjF31u9BjcZKpMlWHoA6aR2NzZAEOSP1W5vJ/EOml1jtXsMOw5hgzwLQAmZXUkgZPZV37x5k/lN8s0M4ZCCNL+UcONBXyJfYt+8FmV5SrAy3b1n19/iM6QVEylIw7hRH9ry3knpSrRYYvQLDWBdD8I0dxucQM3mS+rfJtlo13cGHCVtS6AXJNl423MJ/D91wzSfbAZVAoekTpDmUwBgmORNQU8AQLAdNcybbdGxc7sKkkx7H4C48tab1ADUNhtaw0fOHSKKrUq1yrY8gm0AcwDzdW3VsXOHSNTMmZ9z7x4nH2PfdCrVKiSnsW86QLWew0nkm+5m4BA4l8VTHMWNem/bcgdc+rTZJB9i3/R3fXfAzzAB+XdBV/Ug8s29Le7MqwIA4Ufe1GLZAjzwHLPoovjX/QEPs4Rc2oLRLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/easyRight.png
// module id = qqLY
// module chunks = 0